// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__9e7Hf","bblFadInOut":"Spinner_bblFadInOut__HEjrR"};